<template>
  <div>
    <b-dropdown 
      variant="link" 
      toggle-class="text-dark"
    >
      <template v-slot:button-content class="text-dark">
          Download <span class="d-none d-lg-inline">Image</span>
      </template>

      <b-dropdown-item v-b-modal.premium-promo>640x360</b-dropdown-item>
      <b-dropdown-item v-b-modal.premium-promo>1024x680</b-dropdown-item>
      <b-dropdown-item v-b-modal.premium-promo>1280x720</b-dropdown-item>
      <b-dropdown-item v-b-modal.premium-promo>1920x1080</b-dropdown-item>

      <b-dropdown-divider />
      <b-dropdown-item v-b-modal.premium-promo>Screenshot <span class="text-muted">({{screenWidth}}x{{screenHeight}})</span></b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item v-b-modal.premium-promo>
        <span class="font-italic">Custom</span>
      </b-dropdown-item>
    </b-dropdown>

    <b-modal id="premium-promo" title="Premium Only" footer-class="bg-light d-block">

      <p class="mt-1">When you buy the premium bundle get you get easy image download as well as hundreds of premium gradients.</p>
      <p><strong>No subscription needed</strong> - a one time payment gets you permanent access all gradients.</p>

      <template v-slot:modal-footer="{ cancel }">
        <button class="btn btn-link float-left" @click="cancel()">No Thanks</button>
        <a :href="buyNow" target="_blank" class="btn btn-cta px-3 float-right">
            Get Premium
        </a>
        <router-link to="/premium" class="btn btn-outline-primary px-3 mr-2 float-right">
            Learn More
        </router-link>
      </template>
    </b-modal>

  </div>
</template>

<script>

export default {
  data(){
    return {
      buyNow: 'https://gum.co/OdfQP',
    }
  },
  computed: {
    screenWidth(){
      return window.screen.width;
    },
    screenHeight(){
      return window.screen.height;
    }
  },
  methods: {
    showModal(){
      console.log('modal')
    }
  }
}
</script>

<style lang="scss">
#premium-promo.modal {
  .modal-header {
    border-bottom: 4px solid white;
    border-image: repeating-linear-gradient(90deg, hsl(355,77%,74%) 0px, hsl(355,77%,74%) 70px,hsl(40,77%,74%) 70px, hsl(40,77%,74%) 140px,hsl(85,77%,74%) 140px, hsl(85,77%,74%) 210px,hsl(130,77%,74%) 210px, hsl(130,77%,74%) 280px,hsl(175,77%,74%) 280px, hsl(175,77%,74%) 350px,hsl(220,77%,74%) 350px, hsl(220,77%,74%) 420px,hsl(265,77%,74%) 420px, hsl(265,77%,74%) 490px,hsl(310,77%,74%) 490px, hsl(310,77%,74%) 560px) 27;
  }
}

</style>